(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["srs-custom-article-item"] && !Shopify.designMode) return;
  try {
    window.addEventListener('load', function () {
    let now = null;

    // サーバーのレスポンスヘッダーから時刻を取得（fetch を使用）
    fetch(window.location.href, {
      method: 'HEAD',
      cache: 'no-store',
    })
      .then(function (response) {
        const dateHeader = response.headers.get('Date');
        if (dateHeader) {
          const parsed = new Date(dateHeader);
          if (!isNaN(parsed.getTime())) {
            now = parsed;
          } else {
            now = new Date();
          }
        } else {
          now = new Date();
        }
        // NEWアイコンを表示
        showNewIcon(now);
      })
      .catch(function () {
        // ネットワーク等エラー時はクライアントの時刻を使用
        now = new Date();
        showNewIcon(now);
      });
  });

  /**
   * NEWアイコンを表示する。
   *
   * @callback showNewIcon
   * @param {Date} now 現在時刻
   */
  function showNewIcon(now) {
    // NEWアイコンの要素をリストで取得
    const newIconList = document.getElementsByClassName('new-icon');

    // NEWアイコンごとの処理
    for (let newIcon of newIconList) {
      // ブログ記事の公開日時を取得（存在チェックとパース検証）
      const dateStr = newIcon.dataset.articlePublishedAt;
      if (!dateStr) continue;

      const articlePublishedAt = new Date(dateStr.replace(/-/g, '/'));
      if (isNaN(articlePublishedAt.getTime())) continue;

      // ブログ記事の公開日時から7日後の時刻を取得
      const oneWeekAfterArticlePublishedAt = new Date(articlePublishedAt);
      oneWeekAfterArticlePublishedAt.setDate(oneWeekAfterArticlePublishedAt.getDate() + 7);

      // ブログ記事の公開日時から7日以内の場合
      if (articlePublishedAt <= now && now <= oneWeekAfterArticlePublishedAt) {
        // NEWアイコンを表示
        newIcon.classList.add('show');
      }
    }
  }
  } catch(e) { console.error(e); }
})();

})();
